export function isShallowEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (!(a instanceof Object) || !(b instanceof Object)) {
        return false;
    }
    const keys = Object.keys(a);
    const { length } = keys;
    if (length !== Object.keys(b).length) {
        return false;
    }
    for (let i = 0; i < length; i += 1) {
        const key = keys[i];
        if (!(key in b)) {
            return false;
        }
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
// export const isObjectEqual = <T>(left: T | null | undefined, right: T | null | undefined) => {
// 	if (left === right) return true;
// 	if (left && right) {
// 		const leftKeys = Object.keys(left) as Array<keyof NonNullable<T>>;
// 		const rightKeys = Object.keys(right) as Array<keyof NonNullable<T>>;
// 		if (leftKeys.length !== rightKeys.length) return false;
// 		for (const key of leftKeys) {
// 			if (left[key] !== right[key]) return false;
// 		}
// 		return true;
// 	} else {
// 		if (left && !right) return false;
// 		else if (!left && right) return false;
// 		else return true;
// 	}
// }
export const isArrayEqual = (left, right) => {
    if (left === right)
        return true;
    if (left && right) {
        if (left.length !== right.length)
            return false;
        for (let i = 0; i < left.length; i++) {
            if (left[i] !== right[i])
                return false;
        }
        return true;
    }
    else {
        if (left && !right)
            return false;
        else if (!left && right)
            return false;
        else
            return true;
    }
};
export const isDateEqual = (value1, value2) => {
    if (value1 && value2) {
        return value1.getDate() === value2.getDate() &&
            value1.getMonth() === value2.getMonth() &&
            value1.getFullYear() === value2.getFullYear();
    }
    else if (value1 && !value2)
        return false;
    else if (!value1 && value2)
        return false;
    else
        return true;
};
